SupportUtilsHelper = require('../../helpers/utils')
SupportOrderSummaryTemplate = require('../../../order_summary.html.mustache')
SupportCurrentOrderModel = require('../../models/current_order')
Backbone = require 'backbone'
Backbone.$ = $

class SupportOrderSummaryView extends Backbone.View
  className: 'order-summary'

  initialize: () ->
    @I18nScope = 'modules.support'
    @template = SupportOrderSummaryTemplate
    @orderPresenter = new SupportCurrentOrderModel

  render: ->
    @$el.append toHtml(@template, @buildOrderSummaryParams(), @I18nScope)

  buildOrderSummaryParams: () ->
    @orderPresenter.buildOrderSummaryParams()

module.exports = SupportOrderSummaryView
